import dynamic from "next/dynamic";

export const DynamicContent058 = dynamic(() => import("./Content058"), {
  suspense: true,
});
